//
// locale_uk.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/uk.json';
import localeData from "react-intl/locale-data/uk.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
